require('./ui-bootstrap-tpls');
module.exports = 'ui.bootstrap';



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/index.js
// module id = 391
// module chunks = 3